import ThemeProvider from "design-system/src/General/ThemeProvider/ThemeProvider";
import React from "react";
import { Provider } from "react-redux";
import AlertNoticeDeferredProvider from "./lib/alert-notice/AlertNoticeDeferredProvider";
import store from "./store";
import ModelProvider from "./backbone/provider/ModelProvider";
import { ImageUrlProvider } from "@src/lib/render-image/Context/ImageUrlProvider";
import LinkContext from "design-system/src/Core/Link/Context/LinkContext";
import { StyledLink, LinkWrapper } from "@src/lib/rolling-start-navigation";
import TypographyLink from "@src/lib/rolling-start-navigation/TypographyLink";
import FlexBoxLink from "@src/lib/rolling-start-navigation/FlexBoxLink";
import { IntlProvider } from "gatsby-plugin-intl-sushishop";
import { GATSBY_INTL_DEFAULT_LANG } from "@src/utils/constants";
import DiscountProductDeferredProvider from "@src/lib/DiscountProduct/DiscountProductDeferredProvider";
import EndOfServiceProvider from "./lib/end-of-service/EndOfServiceProvider";
import HappyHourDeferredProvider from "./lib/happyHour/HappyHourDeferredProvider";
import WebViewProvider from "@src/lib/WebView/WebViewProvider";

export type RunContext = "ssr" | "browser";

interface IAppProviderProps {
  children: React.ReactElement;
}

const AppProvider = (props: IAppProviderProps) => {
  const { children } = props;
  return (
    <IntlProvider locale={GATSBY_INTL_DEFAULT_LANG}>
      <Provider store={store}>
        <WebViewProvider>
          <ThemeProvider>
            <ImageUrlProvider>
              <LinkContext.Provider
                value={{ LinkWrapper, StyledLink, TypographyLink, FlexBoxLink }}
              >
                <AlertNoticeDeferredProvider>
                  <ModelProvider>
                    <EndOfServiceProvider>
                      <DiscountProductDeferredProvider>
                        <HappyHourDeferredProvider>
                          {children}
                        </HappyHourDeferredProvider>
                      </DiscountProductDeferredProvider>
                    </EndOfServiceProvider>
                  </ModelProvider>
                </AlertNoticeDeferredProvider>
              </LinkContext.Provider>
            </ImageUrlProvider>
          </ThemeProvider>
        </WebViewProvider>
      </Provider>
    </IntlProvider>
  );
};

export default React.memo(AppProvider);
